<template>
  <div class="kl-faq__header">
    <div class="container d-flex p-0">
      <nav id="faqNav" class="nav kl-tabs">
        <div id="faqNav__content" class="kl-tabs__content">
          <router-link
            id="konto-librus"
            class="nav-link pl-0"
            to="/pomoc/konto-librus"
            exact
          >
            <p class="link-text">Konto&nbsp;LIBRUS</p>
          </router-link>
          <router-link
            id="aplikacja-librus"
            class="nav-link"
            to="/pomoc/aplikacja-librus"
            exact
          >
            <p class="link-text">Aplikacja&nbsp;Librus</p>
          </router-link>
          <router-link
            id="aplikacja-librus-nauczyciel"
            class="nav-link"
            to="/pomoc/aplikacja-librus-nauczyciel"
          >
            <p class="link-text">Aplikacja&nbsp;Librus Nauczyciel</p>
          </router-link>
          <router-link
            id="akademia-librus"
            class="nav-link"
            to="/pomoc/akademia-librus"
            exact
          >
            <p class="link-text">Akademia&nbsp;Librus</p>
          </router-link>
          <router-link id="sklep" class="nav-link" to="/pomoc/sklep">
            <p class="link-text">Sklep</p>
          </router-link>
        </div>
      </nav>
      <button
        id="leftArrow"
        class="kl-arrow kl-arrow--left order-first"
        type="button"
      >
        <arrow-icon
          class="kl-arrow-icon"
          rotate="point-left"
          color="secondary"
          style="height: 16px"
        />
      </button>
      <button
        id="rightArrow"
        class="kl-arrow kl-arrow--right order-last"
        type="button"
      >
        <ArrowIcon
          class="kl-arrow-icon"
          rotate="point-right"
          color="secondary"
          style="height: 16px"
        />
      </button>
    </div>
  </div>
</template>
<script>
import HorizontalNavBar from "./../assets/js/horizontalNavBar";
import ArrowIcon from "./icons/ArrowIcon";

export default {
  name: "FaqHeader",
  components: { ArrowIcon },
  mounted() {
    let id = location.pathname.split("/")[2];
    let element = null;
    if (!id) {
      element = document.getElementById("konto-librus");
    } else {
      element = document.getElementById(id);
    }
    if (element) {
      element.className += " active";
    }
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY || window.pageYOffset;
      window.requestAnimationFrame(() => {
        const breakpoint = document.documentElement.offsetHeight - 207;
        const scrollPos = scrollPosition + window.innerHeight;
        let faqNavElement = document.getElementById("faq-nav");
        if (faqNavElement) {
          if (breakpoint < scrollPos) {
            faqNavElement.style.top = 180 - (scrollPos - breakpoint) + "px";
          } else {
            faqNavElement.style.top = "180px";
          }
        }
      });
    });

    new HorizontalNavBar({
      distance: 150,
      container: document.getElementById("faqNav"),
      content: document.getElementById("faqNav__content"),
      leftArrow: document.getElementById("leftArrow"),
      rightArrow: document.getElementById("rightArrow"),
    });
  },
};
</script>
